import { render, staticRenderFns } from "./AssetPlacementAlter.vue?vue&type=template&id=da5b1096&"
import script from "./AssetPlacementAlter.vue?vue&type=script&lang=js&"
export * from "./AssetPlacementAlter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports